export function getCurrentVersion() {
    return process.env.VUE_APP_VERSION;
}
export function compareVersion(currentVersion, newVersion) {
    let [bigVersions, upgrade, bugRepair] = currentVersion.split('.')
    let [newbigVersions, newupgrade, newbugRepair] = newVersion.split('.')
    if (bigVersions == newbigVersions) {
        if (newupgrade == upgrade) {
            if (newbugRepair == bugRepair) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    } else {
        return true
    }
}

export function getStrPx(str = "", size = 14, weight = 400) {
    let span = document.createElement('span');
    span.style.display = 'inline-block';
    span.style.fontSize = size + 'px';
    span.style.fontWeight = weight;
    span.textContent = str;
    document.body.appendChild(span);
    let length = span.clientWidth
    document.body.removeChild(span);
    return length
}